export enum QuotationStatus {
    Request = "Requested",
    Pending = "Pending",
    Active = "Active",
    Approve = "Approved",
    Reject = "Rejected"
  }
  
 export enum VendorDTO {
    AWS = "AWS",
    Azure = "Azure"
  }

  export enum BillingTerm {
    PAYG = "Monthly",
    ANNUAL = "OneYear"
  }
  
  export enum QuotationType {
    Annual = "Annual",
    MidYear = "MidYear",
    _24x7 = "_24x7",
    Renewal ="Renewal"
  }
  export enum NCacheKeyStatus {
    active = "active",
    inactive = "inactive"
  }

  export const QuotationPathEnum = {
    BUY_NCACHE : "buy_cache",
    EMAIL_LINK : "email_link",
    TRANSACTION_LINK : "transaction_link"
  } as const